import React, { useState, useEffect, useCallback } from "react";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/ViewSpends.scss";
import { useNavigate, useLocation } from "react-router-dom";
import Table from "../../Components/Table";
import {
  getSpendById,
  getSpendTransactionList,
  updateExistingSpend,
} from "../../Services/Spends/action";
import { connect } from "react-redux";
import { Modal, Spinner, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import qs from "query-string";

const ViewSpends = (props) => {
  const {
    spendData,
    loading,
    success,
    getSpend,
    getSpendTransaction,
    spendTransactionData,
    updatingSpend,
    noOfRecords,
  } = props;
  // const { id: spendId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const spendId = location?.state?.id;
  const [spend, setSpend] = useState({});
  const [spendTransaction, setSpendTransaction] = useState([]);
  const [show, setShow] = useState(false);
  const [params, setParams] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [newData, setNewData] = useState({
    id: null,
    title: "",
  });
  const count = spendTransactionData?.length;

  useEffect(() => {
    if (spendId) {
      getSpend(spendId);
    }
  }, [spendId]);

  useEffect(() => {
    if (!spendId) {
      toast.error("Something went wrong");
      navigate("/spends");
    }
  }, []);

  const fetchTransactionData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await getSpendTransaction(spendId, location.search);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    spendId && fetchTransactionData();
  }, [spendId, location.search]);

  useEffect(() => {
    if (spendData) {
      setSpend(spendData);
    }

    if (spendTransactionData) {
      let transactions = spendTransactionData?.map((transaction, index) => {
        return {
          "Sr No": {
            value: index + 1,
            type: "text",
          },
          Type: {
            value: transaction?.transactionSpendMap?.type,
            type: (transaction?.transactionSpendMap?.type).toLowerCase(),
          },
          Description: {
            value: transaction?.transactionSpendMap?.description,
            type: "description",
          },
          "Transaction Amount": {
            value: transaction?.transactionSpendMap?.amount,
            type: "amount",
          },
          "Spend Amount": {
            value: transaction?.amount,
            type: "amount",
          },
          "Share Holders": {
            value:
              transaction?.transactionSpendMap?.transactionShareHolderMap?.map(
                (sh) => ({
                  name: sh?.shareHolderTransactionMap?.name,
                  id: sh?.shareHolderTransactionMap?.id,
                })
              ) || [],
            type: "share holder",
          },
          Date: {
            value: transaction?.transactionSpendMap?.transaction_date.split(" ")[0],
            type: "date",
          },
          Invoices: {
            value:
              transaction?.transactionSpendMap?.transactionInvoiceMap?.map(
                (inv) => ({ id: inv?.invoice_id })
              ) || [],
            type: "invoices",
          },
          // Action: {
          //   value: "/transaction/edit",
          //   value2: "/transaction/view",
          //   type: "action",
          // },
        };
      });
      setSpendTransaction(transactions);
    }
  }, [spendData, spendTransactionData]);

  const header = [
    { field: "Sr No" },
    { field: "Type" },
    { field: "Transaction Amount" },
    { field: "Spend Amount" },
    { field: "Description" },
    { field: "Share Holders" },
    { field: "Invoices" },
    { field: "Date" }
    // { field: "Action" },
  ];

  let footer = true;

  const handleClose = () => {
    setShow(false);
    setNewData({
      ...spendData,
      id: null,
      name: "",
    });
  };

  const handleSpendUpdate = (e, spend) => {
    e.preventDefault();
    setNewData({
      ...newData,
      id: spend?.id,
      name: spend?.name,
    });
    setShow(true);
  };

  const handleSpendSubmit = async () => {
    if (newData?.name) {
      try {
        let response = await updatingSpend(newData?.id, newData);
        if (!loading && success) {
          setNewData({
            id: null,
            name: "",
          });
          setShow(false);
        }
        setIsLoading(true);
        setTimeout(async () => {
          await getSpend(newData?.id);
          setIsLoading(true);
        }, 1000);
      } catch (error) {
        toast.error("Error:", error);
      }
    } else {
      toast.error("Oops, Not valid: Please Insert Valid title of spend");
      return;
    }
  };

  return (
    <Sidebarlayout>
      {(loading && isLoading) ? (
        <div className="d-flex">
          <Spinner animation="rounded" size="sm" /> Loading Spend Data...
        </div>
      ) : (
        <div className="viewSpends-main">
          <div className="page-title">
            <h4>{spend?.spendDetails?.name}</h4>
            <div className="edit-btn">
              <button
                type="button"
                className="custom-btn"
                onClick={(e) => handleSpendUpdate(e, spend?.spendDetails)}
              >
                Edit
              </button>
            </div>
          </div>
          <div className="tiles-division">
            <div className="row">
              <div className="col-lg-4">
                <div className="tiles-container tiles-1">
                  <div className="text-content">
                    <h6 className="highlight-text">Total</h6>
                    <div className="bottom-text">
                      <h6 className="amount-text">{`₹${spend?.totalAmount}`}</h6>
                      <span className="small-text">
                        Total amount of {spend?.spendDetails?.name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="tiles-container tiles-2">
                  <div className="text-content">
                    <h6 className="highlight-text">This Month</h6>
                    <div className="bottom-text">
                      <h6 className="amount-text">{`₹${spend?.thisMonthAmount}`}</h6>
                      <span className="small-text">Total amount of month</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="tiles-container tiles-3">
                  <div className="text-content">
                    <h6 className="highlight-text">This Year</h6>
                    <div className="bottom-text">
                      <h6 className="amount-text">{`₹${spend?.thisYearAmount}`}</h6>
                      <span className="small-text">Total amount of year</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="spend-details">
            <h6 className="heading-title">Transaction List</h6>
            <Table
              header={header}
              data={spendTransaction}
              footer={footer}
              count={count}
              records={parseFloat(noOfRecords)}
              defaultParams={params}
              loading={loading}
            />
          </div>
        </div>
      )}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Spend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="Spend-input-block">
            <h6 className="label mb-1" htmlFor="name">
              Title
            </h6>
            <input
              className="input-css"
              type="text"
              name="name"
              id="name"
              value={newData?.name}
              onChange={(e) => {
                setNewData({ ...newData, name: e.target.value });
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancle
          </Button>
          <Button variant="primary" onClick={handleSpendSubmit}>
            {loading ? <Spinner size="sm" animation="rounded" /> : "Save Spend"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Sidebarlayout>
  );
};

export const mapStateToProps = (state) => {
  return {
    spendData: state.spendReducer.spend,
    spendTransactionData: state.spendReducer.spendTransactions.rows,
    loading: state.spendReducer.loading,
    success: state.spendReducer.success,
    noOfRecords: state.spendReducer.spendTransactions.noOfRecords,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getSpend: (id) => {
      dispatch(getSpendById(id));
    },
    getSpendTransaction: (id, param) => {
      dispatch(getSpendTransactionList(id, param));
    },
    updatingSpend: (id, data) => {
      dispatch(updateExistingSpend(id, data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSpends);
